import _typeof from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof";
import React from 'react';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var classnames$1 = {
  exports: {}
};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames$1);

var classnames = classnames$1.exports;
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/** Used to match HTML entities and HTML characters. */

var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);
/** Used to map HTML entities to characters. */

var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&#96;': '`'
};
/** Detect free variable `global` from Node.js. */

var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */


var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
/** Used for built-in method references. */

var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var _Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */


function unescape(string) {
  string = toString(string);
  return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
}

var lodash_unescape = unescape;
var reactErrorBoundary_umd = {
  exports: {}
};

(function (module, exports) {
  (function (global, factory) {
    factory(exports, React);
  })(commonjsGlobal, function (exports, React) {
    function _interopNamespace(e) {
      if (e && e.__esModule) return e;
      var n = Object.create(null);

      if (e) {
        Object.keys(e).forEach(function (k) {
          if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
              enumerable: true,
              get: function get() {
                return e[k];
              }
            });
          }
        });
      }

      n['default'] = e;
      return Object.freeze(n);
    }

    var React__namespace = /*#__PURE__*/_interopNamespace(React);

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;

      _setPrototypeOf(subClass, superClass);
    }

    var changedArray = function changedArray(a, b) {
      if (a === void 0) {
        a = [];
      }

      if (b === void 0) {
        b = [];
      }

      return a.length !== b.length || a.some(function (item, index) {
        return !Object.is(item, b[index]);
      });
    };

    var initialState = {
      error: null
    };

    var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(ErrorBoundary, _React$Component);

      function ErrorBoundary() {
        var _this;

        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
        _this.state = initialState;
        _this.updatedWithError = false;

        _this.resetErrorBoundary = function () {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

          _this.reset();
        };

        return _this;
      }

      ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
        return {
          error: error
        };
      };

      var _proto = ErrorBoundary.prototype;

      _proto.reset = function reset() {
        this.updatedWithError = false;
        this.setState(initialState);
      };

      _proto.componentDidCatch = function componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;

        (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
      };

      _proto.componentDidMount = function componentDidMount() {
        var error = this.state.error;

        if (error !== null) {
          this.updatedWithError = true;
        }
      };

      _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var error = this.state.error;
        var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
        // happens to *also* be in the resetKeys array, we'd end up resetting
        // the error boundary immediately. This would likely trigger a second
        // error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call
        // of cDU after the error is set

        if (error !== null && !this.updatedWithError) {
          this.updatedWithError = true;
          return;
        }

        if (error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
          var _this$props$onResetKe, _this$props3;

          (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
          this.reset();
        }
      };

      _proto.render = function render() {
        var error = this.state.error;
        var _this$props4 = this.props,
            fallbackRender = _this$props4.fallbackRender,
            FallbackComponent = _this$props4.FallbackComponent,
            fallback = _this$props4.fallback;

        if (error !== null) {
          var _props = {
            error: error,
            resetErrorBoundary: this.resetErrorBoundary
          };

          if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
            return fallback;
          } else if (typeof fallbackRender === 'function') {
            return fallbackRender(_props);
          } else if (FallbackComponent) {
            return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
          } else {
            throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
          }
        }

        return this.props.children;
      };

      return ErrorBoundary;
    }(React__namespace.Component);

    function withErrorBoundary(Component, errorBoundaryProps) {
      var Wrapped = function Wrapped(props) {
        return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
      }; // Format for display in DevTools


      var name = Component.displayName || Component.name || 'Unknown';
      Wrapped.displayName = "withErrorBoundary(" + name + ")";
      return Wrapped;
    }

    function useErrorHandler(givenError) {
      var _React$useState = React__namespace.useState(null),
          error = _React$useState[0],
          setError = _React$useState[1];

      if (givenError != null) throw givenError;
      if (error != null) throw error;
      return setError;
    }
    /*
    eslint
      @typescript-eslint/no-throw-literal: "off",
      @typescript-eslint/prefer-nullish-coalescing: "off"
    */


    exports.ErrorBoundary = ErrorBoundary;
    exports.useErrorHandler = useErrorHandler;
    exports.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
  });
})(reactErrorBoundary_umd, reactErrorBoundary_umd.exports);

export { classnames as c, lodash_unescape as l, reactErrorBoundary_umd as r };